import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { getInternetConnectionMasterList_action, insertUpdateInternetConnectionMaster_action } from '../../../../../actions/admin_module_action/master_action/manual_form_master_action/internet_connection_master_action'
import { fill_action } from '../../../../../actions/fillCombo_action'
import { BASE_URL, countryActionId, toastError, toastSuccess, visaIdTypeActionId } from "../../../../../utils/constants";
import { emailValidator, mobileNoValidator } from "../../../../../utils/Validator";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import Resizer from "react-image-file-resizer";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import Passport_Front_1008_VIS_903747 from "../../../../../files/Passport_Front_1008_VIS_903747.jpeg"

class InternetConnectionMasterAU extends Component {

    // initialize constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            editID: null,
            // fields
            BankName: '',
            Address: "",
            AccountNumber: '',
            RTGS_IFSC: '',
            BeneficiaryName: '',
            BeneficiaryAddress: '',
            SwiftCode: '',
            PAN: '',
            GST: '',
            Name: "",
            Phone: '',
            Mobile: '',
            Fax: '',
            Email: '',
            Designation: '',
            // List
            internetConnectionList: [],
            BankNameErr: '',
            AddressErr: "",
            AccountNumberErr: '',
            RTGS_IFSCErr: '',
            NameErr: "",
            PhoneErr: '',
            MobileErr: '',
            FaxErr: '',
            EmailErr: '',
            DesignationErr: '',
            index: 1,
        }
        this.OnCancel = this.OnCancel.bind(this)
        this.inputValidate = this.inputValidate.bind(this)
        this.renderInternetConnectionList = this.renderInternetConnectionList.bind(this)
        this.handleAddMore = this.handleAddMore.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.ClearValue = this.ClearValue.bind(this)
    }

    componentDidMount() {
        const locState = this.props.location.state
        const editData = locState && locState.editData ? locState.editData : null
        if (editData) {
            this.setState({
                Name: editData.Name || '', Phone: editData.Phone || '',
                Mobile: editData.Mobile || '', Fax: editData.Fax || '',
                Email: editData.Email || '', Designation: editData.Designation || '',
                BankName: editData.BankName || '',
                Address: editData.Address || '',
                AccountNumber: editData.AccountNumber || '',
                RTGS_IFSC: editData.RTGS_IFSC || '',
                BeneficiaryName: editData.BeneficiaryName || '',
                BeneficiaryAddress: editData.BeneficiaryAddress || '',
                SwiftCode: editData.SwiftCode || '',
                PAN: editData.PAN || '',
                GST: editData.GST || '',
                editID: editData.InternetConnectionContactPersonID || null,
            })
        }
        this.getInternetConnectionMasterList(editData ? editData.InternetConnectionContactPersonID : null)
    }

    // On cancel Click
    OnCancel() {
        this.props.navigate('/internetConnectionMasterList')
    }

    getInternetConnectionMasterList(editID) {
        this.setState({ isLoading: true })
        this.props.getInternetConnectionMasterList_action()
            .then((data) => {
                if (data.error != 1) {
                    let list = data.data[0] || []
                    if (editID) {
                        list = list.filter(r => r.InternetConnectionContactPersonID !== editID)
                    }
                    list = list.map((r, i) => ({ ...r, isShow: true, index: i + 1 }))
                    this.setState({ internetConnectionList: list, index: list.length + 1 })
                    this.setState({ isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // Input Fields Validation
    inputValidate() {
        const { Name, Mobile, Email, Designation } = this.state
        if (Name == "") {
            this.setState({ NameErr: "Please Enter Name" })
        }
        if (Designation == "") {
            this.setState({ DesignationErr: "Please Enter Designation" })
        }
        if (Mobile == "") {
            this.setState({ MobileErr: "Please Enter Mobile No." })
        }
        if (Email == "") {
            this.setState({ EmailErr: "Please Enter Email" })
        } else {
            var Emailerr = (emailValidator(Email) == '') ? false : emailValidator(Email)
            if (Emailerr) {
                this.setState({ EmailErr: "Please Enter Proper Email" })
            }
        }
    }

    renderInternetConnectionList() {
        const { internetConnectionList } = this.state
        return (
            <ul class="list-group " style={{ position: 'relative', zIndex: 1 }}>
                {
                    internetConnectionList.length > 0 && internetConnectionList.map((data, index) => (
                        data.isShow &&
                        <li class="list-group-item" key={Math.random()}>
                            <div className="added-more p-3 rounded-2">
                                <h5 style={{ color: "#0056ff" }}>Added Internet Connection Master {data.index}</h5>
                                <h6 >Agency Contact </h6>
                                <div className="row mt-4">
                                    <div className="col-md-4">
                                        <h6>Name: {data.Name}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Mobile no.: {data.Mobile}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Designation: {data.Designation}</h6>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-4">
                                        <h6>Telephone: {data.Phone}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Fax: {data.Fax}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Email: {data.Email}</h6>
                                    </div>
                                </div>
                            </div>
                            <hr className="m-1" />
                            <div className="added-more p-3 rounded-2">
                                <h6>Bank Details </h6>
                                <div className="row mt-4">
                                    <div className="col-md-3">
                                        <h6>Bank Name: {data.BankName}</h6>
                                    </div>
                                    <div className="col-md-6">
                                        <h6>Branch / Bank Address: {data.Address}</h6>
                                    </div>
                                    <div className="col-md-3">
                                        <h6>Account Number: {data.AccountNumber}</h6>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <h6>Beneficiary Name: {data.BeneficiaryName}</h6>
                                    </div>
                                    <div className="col-md-6">
                                        <h6>Beneficiary Address: {data.BeneficiaryAddress}</h6>
                                    </div>
                                    <div className="col-md-3">
                                        <h6>Swift Code: {data.SwiftCode}</h6>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-4">
                                        <h6>RTGS IFSC: {data.RTGS_IFSC}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>PAN Number: {data.PAN}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>GST Number: {data.GST}</h6>
                                    </div>
                                </div>
                            </div>
                        </li>
                    ))
                }
            </ul>
        )
    }

    handleAddMore() {
        const { BankName, Address, AccountNumber, RTGS_IFSC, BeneficiaryName, BeneficiaryAddress, SwiftCode, PAN, GST,
            Name, Phone, Mobile, Fax, Email, Designation, internetConnectionList, index,
            NameErr, MobileErr, EmailErr, DesignationErr } = this.state
        this.inputValidate()
        if (Name != '' && Mobile != '' && Email != '' && Designation != '') {
            if (NameErr == '' && EmailErr == '' && MobileErr == '' && DesignationErr == '') {
                internetConnectionList.push({
                    'BankName': BankName,
                    'Address': Address,
                    'AccountNumber': AccountNumber,
                    'RTGS_IFSC': RTGS_IFSC,
                    'BeneficiaryName': BeneficiaryName,
                    'BeneficiaryAddress': BeneficiaryAddress,
                    'SwiftCode': SwiftCode,
                    'PAN': PAN,
                    'GST': GST,
                    'Name': Name,
                    'Phone': Phone,
                    'Mobile': Mobile,
                    'Fax': Fax,
                    'Email': Email,
                    'Designation': Designation,
                    'index': index,
                    'isShow': true,
                })
                setTimeout(() => { this.ClearValue() }, 200);
            }
        }
        console.log(this.state.internetConnectionList)
    }

    handleSave() {
        const { internetConnectionList, Name, Phone, Mobile, Fax, Email, Designation,
            BankName, Address, AccountNumber, RTGS_IFSC, BeneficiaryName, BeneficiaryAddress, SwiftCode, PAN, GST } = this.state

        this.inputValidate()
        if (!Name || !Mobile || !Email || !Designation) {
            toastError('Please enter mandatory fields')
            return
        }

        const currentFormEntry = {
            Name, Phone, Mobile, Fax, Email, Designation,
            BankName, Address, AccountNumber, RTGS_IFSC,
            BeneficiaryName, BeneficiaryAddress, SwiftCode, PAN, GST,
        }
        const listToSave = [currentFormEntry, ...internetConnectionList]

        this.setState({ isLoading: true })
        this.props.insertUpdateInternetConnectionMaster_action(listToSave)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Record Added Successfully")
                    setTimeout(() => {
                        this.setState({ isLoading: false })
                        this.props.navigate('/internetConnectionMasterList')
                    }, 300);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    ClearValue() {
        this.setState({
            BankName: '',
            Address: "",
            AccountNumber: '',
            RTGS_IFSC: '',
            BeneficiaryName: '',
            BeneficiaryAddress: '',
            SwiftCode: '',
            PAN: '',
            GST: '',
            Name: "",
            Phone: '',
            Mobile: '',
            Fax: '',
            Email: '',
            Designation: '',
            index: this.state.index + 1
        })
    }

    render() {
        const { isLoading, editID, BankName, Address, AccountNumber, RTGS_IFSC,
            BeneficiaryName, BeneficiaryAddress, SwiftCode, PAN, GST,
            Name, Phone, Mobile, Fax, Email, Designation, internetConnectionList,
            BankNameErr, AddressErr, AccountNumberErr, RTGS_IFSCErr,
            NameErr, MobileErr, EmailErr, DesignationErr
        } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="main-container">
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Internet Connection Master</h6>
                            </div>
                        </div>
                        <div className="admin-top-space p-2 pt-0">
                                    <div
                                        className="card-header p-2"
                                        style={{ paddingLeft: "7px !important" }}
                                    >
                                        <h3 className="card-title" style={{ fontSize: 15 }}>
                                            Agency contact
                                        </h3>
                                    </div>
                                    <div className="card-body p-2 mt-1">
                                        <div className="row">
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Name<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={Name}
                                                    onChange={(e) => this.setState({ Name: e.target.value, NameErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{NameErr}</span>}

                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Mobile No.<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    placeholder="Use / to separate multiple numbers"
                                                    value={Mobile}
                                                    onChange={(e) => this.setState({ Mobile: e.target.value, MobileErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{MobileErr}</span>}

                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Designation<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={Designation}
                                                    onChange={(e) => this.setState({ Designation: e.target.value, DesignationErr: '' })}
                                                />

                                                {<span className='text-danger text-start text-left d-block mt-1'>{DesignationErr}</span>}
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Telephone
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    placeholder="Use / to separate multiple numbers"
                                                    value={Phone}
                                                    onChange={(e) => this.setState({ Phone: e.target.value, })}
                                                />
                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Fax
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    placeholder="Use / to separate multiple numbers"
                                                    value={Fax}
                                                    onChange={(e) => this.setState({ Fax: e.target.value, })}
                                                />
                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">Email<span className="text-red">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={Email}
                                                    onChange={(e) => this.setState({ Email: e.target.value, EmailErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{EmailErr}</span>}
                                            </div>
                                        </div>
                                    </div>
                                <div className="">
                                    <div
                                        className="card-header p-2"
                                        style={{ paddingLeft: "7px !important" }}
                                    >
                                        <h3 className="card-title" style={{ fontSize: 15 }}>
                                            Bank Details
                                        </h3>
                                    </div>
                                    <div className="card-body p-2 mt-1">
                                        <div className="row">
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">
                                                    Bank Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={BankName}
                                                    onChange={(e) => this.setState({ BankName: e.target.value, BankNameErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{BankNameErr}</span>}
                                            </div>
                                            <div className="col-xl-6">
                                                <label htmlFor="validationCustom03">
                                                    Bank Branch / Address
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={Address}
                                                    onChange={(e) => this.setState({ Address: e.target.value, AddressErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{AddressErr}</span>}
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">
                                                    Account Number
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={AccountNumber}
                                                    onChange={(e) => this.setState({ AccountNumber: e.target.value, AccountNumberErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{AccountNumberErr}</span>}
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">
                                                    Beneficiary Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={BeneficiaryName}
                                                    onChange={(e) => this.setState({ BeneficiaryName: e.target.value })}
                                                />
                                            </div>
                                            <div className="col-xl-6">
                                                <label htmlFor="validationCustom03">
                                                    Beneficiary Address
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={BeneficiaryAddress}
                                                    onChange={(e) => this.setState({ BeneficiaryAddress: e.target.value })}
                                                />
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">
                                                    Swift Code
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={SwiftCode}
                                                    onChange={(e) => this.setState({ SwiftCode: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">RTGS IFSC Code</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={RTGS_IFSC}
                                                    onChange={(e) => this.setState({ RTGS_IFSC: e.target.value, RTGS_IFSCErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{RTGS_IFSCErr}</span>}
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">PAN Number</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={PAN}
                                                    onChange={(e) => this.setState({ PAN: e.target.value })}
                                                />
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">GST Number</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={GST}
                                                    onChange={(e) => this.setState({ GST: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="p-2 save-can d-block">
                                    <div className="row">
                                        <div className="text-end" role="group" aria-label="Basic example">
                                            <button
                                                type="button"
                                                className="btn btn-aqua"
                                                onClick={() => this.handleSave()}
                                            >
                                                Save
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-gray ms-2"
                                                onClick={() => this.OnCancel()}
                                            >
                                                Back
                                            </button>
                                        </div>
                                    </div>
                                </div>


                        </div>
                    </div>
                    </div>
                </>
            </>
        )
    }
}
export default withRouter(connect(null, { getInternetConnectionMasterList_action, insertUpdateInternetConnectionMaster_action, fill_action })(InternetConnectionMasterAU))
